import React, { useEffect, useState } from "react"
import Element from "@bappweb/element"
import Panel from "@bappweb/panel"
import { useDeviceSize, Sizes } from "@bappweb/provider"
import Page from "@smpu-web/globalmodules/page"
import { useGetConfigMutation } from "../../../api/services"
import "../assets/style.scss"
import Table from "./table"
import List from "@bappweb/list"
import { getCidParameter } from "@smpu-web/utils/utils"

const Campaign = () => {
    const size = useDeviceSize()
    const [getConfig] = useGetConfigMutation();
    const [campaingsTable, setCampaingsTable] = useState<any[]>([]);
    const [campaingsHeader, setCampaingsHeader] = useState<any[] | null>(null);
    const [campaingsHeaderMobil, setCampaingsHeaderMobil] = useState<any[] | null>(null);
    const [campaingsTableText, setCampaingsTableText] = useState('');
    let cidParameter = getCidParameter();
    useEffect(() => {
        if (cidParameter != null) {
            let configText = size == Sizes.xs ? `PosLead.CampaignText.Landing.Table.Mobile.${cidParameter}` : `PosLead.CampaignText.Landing.Table.${cidParameter}`
            getConfig(configText)
                .unwrap()
                .then((payload) => {
                    if (!payload.IsError && payload.configValue) {
                        const campaignRefList = JSON.parse(payload.configValue) ?? []
                        setCampaingsTable(campaignRefList)
                    }
                    else {
                        let configText = size == Sizes.xs ? "PosLead.CampaignText.Landing.Table.Mobile" : "PosLead.CampaignText.Landing.Table"
                        getConfig(configText)
                            .unwrap()
                            .then((payload) => {
                                if (!payload.IsError && payload.configValue) {
                                    const campaignRefList = JSON.parse(payload.configValue) ?? []
                                    setCampaingsTable(campaignRefList)
                                }
                            })
                    }
                })
        }
        else {
            let configText = size == Sizes.xs ? "PosLead.CampaignText.Landing.Table.Mobile" : "PosLead.CampaignText.Landing.Table"
            getConfig(configText)
                .unwrap()
                .then((payload) => {
                    if (!payload.IsError) {
                        const campaignRefList = JSON.parse(payload.configValue) ?? []
                        setCampaingsTable(campaignRefList)
                    }
                })
        }
    }, [getConfig, size])

    useEffect(() => {
        if (cidParameter != null) {
            getConfig(`PosLead.CampaignText.Landing.Table.Header.${cidParameter}`)
                .unwrap()
                .then((payload) => {
                    if (!payload.IsError && payload.configValue) {
                        setCampaingsHeader(JSON.parse(payload.configValue))
                    }
                    else {
                        getConfig("PosLead.CampaignText.Landing.Table.Header")
                            .unwrap()
                            .then((payload) => {
                                if (!payload.IsError && payload.configValue) {
                                    setCampaingsHeader(JSON.parse(payload.configValue))
                                }
                            })
                    }
                })
        }
        else {
            getConfig("PosLead.CampaignText.Landing.Table.Header")
                .unwrap()
                .then((payload) => {
                    if (!payload.IsError) {
                        setCampaingsHeader(JSON.parse(payload.configValue))
                    }
                })
        }
    }, [getConfig])

    useEffect(() => {
        if (cidParameter != null) {
            getConfig(`PosLead.CampaignText.Landing.Table.Mobile.Header.${cidParameter}`)
                .unwrap()
                .then((payload) => {
                    if (!payload.IsError && payload.configValue) {
                        setCampaingsHeaderMobil(JSON.parse(payload.configValue))
                    }
                    else {
                        getConfig("PosLead.CampaignText.Landing.Table.Mobile.Header")
                            .unwrap()
                            .then((payload) => {
                                if (!payload.IsError && payload.configValue) {
                                    setCampaingsHeaderMobil(JSON.parse(payload.configValue))
                                }
                            })
                    }
                })
        }
        else {
            getConfig("PosLead.CampaignText.Landing.Table.Mobile.Header")
                .unwrap()
                .then((payload) => {
                    if (!payload.IsError) {
                        setCampaingsHeaderMobil(JSON.parse(payload.configValue))
                    }
                })
        }
    }, [getConfig])

    useEffect(() => {
        if (cidParameter != null) {
            getConfig(`PosLead.CampaignText.Landing.Table.Text.${cidParameter}`)
                .unwrap()
                .then((payload) => {
                    if (!payload.IsError && payload.configValue) {
                        setCampaingsTableText(payload.configValue)
                    }
                    else {
                        getConfig("PosLead.CampaignText.Landing.Table.Text")
                            .unwrap()
                            .then((payload) => {
                                if (!payload.IsError && payload.configValue) {
                                    setCampaingsTableText(payload.configValue)
                                }
                            })
                    }
                })
        }
        else {
            getConfig("PosLead.CampaignText.Landing.Table.Text")
                .unwrap()
                .then((payload) => {
                    if (!payload.IsError) {
                        setCampaingsTableText(payload.configValue)
                    }
                })
        }
    }, [getConfig])

    return (
        <Page padding={false}>
            <Panel hasFooter={false} noHeader className="accordion-container">
                <Element type="h2" dangerouslySetInnerHTML={{ __html: campaingsTableText }} />
                <List
                    accordion
                    accordionCollapsible
                    activeItem={0}
                    custom={false}
                    disabled={false}
                    expandOnlyOne
                    withPadding
                    withoutBorder={false}
                >
                    <List.Item
                        accordion={false}
                        accordionCollapsible
                        disabled={false}
                        preventDefault
                        title={"Kampanyalar/ Oran Tablosu"}
                        withPadding={true}
                    >
                        {campaingsTable && campaingsHeader && campaingsHeaderMobil && campaingsTable.map((item, index) => {
                            return (<Table key={index} tableData={item.data} index={index} campaingsHeader={campaingsHeader} campaingsHeaderMobil={campaingsHeaderMobil} />)
                        })}
                    </List.Item>
                </List>
            </Panel>
        </Page>
    )
}

export default Campaign
